(function () {
  const videos = document.querySelectorAll('.video__wrap');
  if (videos.length > 0) {
    videos.forEach((video) => {
      const playBtn = video.querySelector('.btn-play');
      if (!playBtn) return;
      playBtn.addEventListener('click', (e) => {
        video.querySelector('.cover-image').classList.add('visually-hidden');
        let videoEl = video.querySelector('video');
        let isYoutube = false;

        if (!videoEl) {
          videoEl = video.getElementsByTagName('iframe')[0];
          isYoutube = true;
        }

        setTimeout(function () {
          if (isYoutube) {
            videoEl.setAttribute('src', videoEl.getAttribute('src') + '?autoplay=1');
          } else {
            videoEl.play();
          }
        }, 500);
      });
    });
  }
})();
